/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchUpdateRequestsDto
 */
export interface BatchUpdateRequestsDto {
    /**
     * Action to perform
     * @type {string}
     * @memberof BatchUpdateRequestsDto
     */
    action: BatchUpdateRequestsDtoActionEnum;
    /**
     * Array of request IDs
     * @type {Array<string>}
     * @memberof BatchUpdateRequestsDto
     */
    requestIds: Array<string>;
}


/**
 * @export
 */
export const BatchUpdateRequestsDtoActionEnum = {
    Approve: 'approve',
    Reject: 'reject',
    Revoke: 'revoke',
    Reactivate: 'reactivate'
} as const;
export type BatchUpdateRequestsDtoActionEnum = typeof BatchUpdateRequestsDtoActionEnum[keyof typeof BatchUpdateRequestsDtoActionEnum];


/**
 * Check if a given object implements the BatchUpdateRequestsDto interface.
 */
export function instanceOfBatchUpdateRequestsDto(value: object): value is BatchUpdateRequestsDto {
    if (!('action' in value) || value['action'] === undefined) return false;
    if (!('requestIds' in value) || value['requestIds'] === undefined) return false;
    return true;
}

export function BatchUpdateRequestsDtoFromJSON(json: any): BatchUpdateRequestsDto {
    return BatchUpdateRequestsDtoFromJSONTyped(json, false);
}

export function BatchUpdateRequestsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchUpdateRequestsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'action': json['action'],
        'requestIds': json['requestIds'],
    };
}

export function BatchUpdateRequestsDtoToJSON(json: any): BatchUpdateRequestsDto {
    return BatchUpdateRequestsDtoToJSONTyped(json, false);
}

export function BatchUpdateRequestsDtoToJSONTyped(value?: BatchUpdateRequestsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'action': value['action'],
        'requestIds': value['requestIds'],
    };
}

